import { ContainerLocationStatus } from '@/utils/containerLocation';
import { IUser } from './userInterfaces';
import { IdName } from '../../components/EditMerchantOrder/HandleStatusChange';
import { ReducedStore } from './UserDetailTab';

export interface IUserLocation {
  id: number;
  ownerSince: string;
  ownerId: string;
  owner: IUser | null;
  containerId: string;
  containerName: string;
  status: ContainerLocationStatus;
  returnDeadline: string;
}

export interface ISubscription {
  start: string;
  end: string;
  name: string;
}

export enum TransactionType {
  checkin,
  checkout,
}

export interface ITransaction {
  locationId: number;
  userId: string;
  containerId: string;
  containerName: string;
  transactionPartnerId: string;
  transactionPartnerName: string;
  type: TransactionType;
  transactionTime: string;
}

export interface UserPageState {
  locations: IUserLocation[];
  transactionHistory: ITransaction[];
  subscription: ISubscription | null;
  oneTimeToken: string | null;
  user: IUser | null;
  newPassword: string | null;
  hasErrorLoading: boolean;
  phoneNumber: string | null;
  newPhoneNumber: string | null;
  isPhoneNumberChangeConfirmationModalOpen: boolean;
  isPhoneNumberChangeModalOpen: boolean;
  changePhoneNumberError: string;
  currentTab: number;
  showSetCheckoutLimitModal: boolean;
  showDeleteUserModal: boolean;
  newCheckoutLimit: number;
  newCheckoutLimitIsUnlimited: boolean;
  newCheckoutLimitIsDefault: boolean;
  linkedStore: ReducedStore | null;
  firstCheckoutStore: ReducedStore | null;
  sendDeletionEvent: boolean;
  userClaim: string | null;
  transactionHistoryLoaded: boolean;
  transactionHistoryLoading: boolean;
  linkedStoreContainerStations: IdName[] | null;
}

export interface UserDetailsResponse {
  user: IUser;
  currentLocations: IUserLocation[];
  subscription: ISubscription | null;
  oneTimeToken: string | null;
  phoneNumber: string | null;
  linkedStoreId: string | null;
  linkedStore: ReducedStore | null;
  firstCheckoutStore: ReducedStore | null;
  storeContainerStations: IdName[];
}
